import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../Helper/Context/context";
import { SamplePlantDetailsDeleteAPI, SamplePlantDetailsPopUpTableDataAPI, SamplePlantDetailsPostAPI } from "../../../../Helper/Redux/AdminDashboardSlice/SamplePlantDetailsSlice";
import { useEffect, useState } from "react";
import { Loading } from "../../../../Helper/LogoLoader/LogoLoader";
import DeletePopUP from "../../../CommonPopUp/DeletePopUp";
import { ConditionNameDDL } from "../../../CommonDDL/ConditionNameDDL";


const SamplePlantNoOfPopup = (props) => {

    const { handleShowAddModal, handleIsPost, ShowAddModal, YearValue, MonthValue, Title,IsDeleteDataPost,setIsDeleteDataPost } = props
    const { flag, data } = ShowAddModal

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token, RoleID, IndicatorGrievanceAreaID } = userDetails


    const [DeleteViewPopup, setDeleteViewPopup] = useState(false)
    const [GridData, setGridData] = useState([])
    const [RowIndex, setRowIndex] = useState()
    const [IsDataPost, setIsDataPost] = useState(false)
    const [IsClear, setIsClear] = useState(false)

    const [ShowDeletePopup, setShowDeletePopup] = useState(false)
    const [ShowDeletePopupData, setShowDeletePopupData] = useState({
        data: ''
    })

    const [SamplePlantNoTextField, setSamplePlantNoTextField] = useState({
        Year: '',
        Month: '',
        NoOfPlant: '',
        Height: '',
        Girth: '',
        Condition: '',
        NoofPlantDiedatHome: '',
    })

    const [ConditionID, setConditionID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    // const handleShowUpdate = (index) => {
    //     // setRowIndex(index)
    //     setUpdateViewPopup(!UpdateViewPopup)
    // }

    // const handleShowDelete = () => {
    //     setDeleteViewPopup(!DeleteViewPopup)
    // }
    const handleShowDelete = (data) => {
        setShowDeletePopup(!ShowDeletePopup)
        { data && setShowDeletePopupData(data) }
    }

    const handleIsDataPost = () => {
        setIsDataPost(!IsDataPost)
        // handleShowDelete()
        // setShowDeletePopup(false)

    }
    const handleIsDeleteData = () => {
        setIsDataPost(!IsDataPost)
        setIsDeleteDataPost(!IsDeleteDataPost)
        handleShowDelete()
        setShowDeletePopup(false)
    }

    const onChange = (index, e) => {
        const { name, value } = e.target;
        var data = [...GridData];
        let x = JSON.parse(JSON.stringify(data));
        x[index][name] = value;
        setGridData(x)
    };


    const handleGetFormData = (result) => {

        if (result && result.length > 0) {
            setGridData(result)
        } else {
            setGridData([])
        }

    }

    useEffect(() => {
        const data = {
            FinancialYearID: YearValue,
            MonthsID: MonthValue,
            T_BeneficiaryWisePlotsDetailsID: ShowAddModal.BeneficiaryPlotsWisePlantDetailsID,
            M_BeneficiaryDetailsID: ShowAddModal.data.m_BeneficiaryDetailsID,
            M_TableUserMasterID: UserID,
            FromTop: 1,
            ToTop: "999999",
            token: token,
            handleGetFormData: handleGetFormData
        }

        dispatch(SamplePlantDetailsPopUpTableDataAPI({ data }))

    }, [IsDataPost, IsClear, YearValue, MonthValue])

    const { isLoading, tableData } = useSelector(state => state.SamplePlantDetailsPopUpTableData)

    const handleSubmit = (index) => {

        const data = {
            T_BeneficiaryPlotsWisePlantDetailsID: GridData[index].t_BeneficiaryPlotsWisePlantDetailsID,
            FinancialYearID: YearValue,
            MonthsID: MonthValue,
            Height: GridData[index].height,
            Girth: GridData[index].girth,
            Condition_M_IndicatorID: ConditionID.ID,
            M_TableUserMasterID: UserID,
            token: token,
            handleIsDataPost

        }
        dispatch(SamplePlantDetailsPostAPI({ data }))
    }

    const { isPostLoading } = useSelector(state => state.SamplePlantDetailsPostData)

    const handleDeleteData = () => {
        // console.log("ShowDeletePopupData?.keepingPlantAtHome_M_IndicatorID",ShowDeletePopupData?.keepingPlantAtHome_M_IndicatorID)
        const data = {
            T_BeneficiaryPlotsWisePlantDetailsID: ShowDeletePopupData?.t_BeneficiaryPlotsWisePlantDetailsID,
            M_TableUserMasterID: UserID,
            token: token,
            handleIsDeleteData:handleIsDeleteData
        }
        dispatch(SamplePlantDetailsDeleteAPI({ data }))
    }

    const { isDeleteLoading } = useSelector(state => state.SamplePlantDetailsDeleteData)

    const handleClear = () => {
        console.log('dgfdg')
        setIsClear(!IsClear)


    }

    return (
        <>

            <div className="modal fade show d-flex align-items-center" style={{ display: "block", backgroundColor: "#00000055" }}>
                {isLoading && <Loading />}
                {isDeleteLoading && <Loading />}
                <div className="modal-dialog modal-lg " style={{ minWidth: '50vw' }} role="document"  >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title fw-bold modal-title-fs text-danger" id="exampleModalLongTitle">{Title}</h5>
                            <button onClick={() => handleShowAddModal(false, '')} type="button" className="close" style={{ marginLeft: "auto" }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" style={{ overflowY: 'scroll', height: '60vh' }}>
                            <div className="row">
                                <div className="col-12">
                                    <div className=" p-0" >
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr className="bg-gradient-dark text-white">
                                                    <th className=" w-6 v_sr_width">Sr. No.</th>
                                                    <th className="text-center" style={{ width: "15%" }}>No. of Plant</th>
                                                    <th className="text-center" style={{ width: "15%" }}>Height</th>
                                                    <th className="text-center" style={{ width: "15%" }}>Girth</th>
                                                    <th className="text-center" style={{ width: "20%" }}>Condition</th>
                                                    <th className="text-center" style={{ width: "10%" }}>Action</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    GridData && GridData.length > 0 ? GridData.map((i, index) => {
                                                        return (

                                                            <tr>
                                                                <td align="center">{index + 1}</td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control mx-auto"
                                                                        name="plant_SerialNumber"
                                                                        // id="financialYearID"                                              
                                                                        placeholder={GridData[index].plant_SerialNumber}
                                                                        onChange={(e) => onChange(index, e)}

                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control mx-auto"
                                                                        name="height"
                                                                        placeholder={GridData[index].height}
                                                                        onChange={(e) => onChange(index, e)}

                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control mx-auto"
                                                                        name="girth"
                                                                        placeholder={GridData[index].girth}
                                                                        onChange={(e) => onChange(index, e)}


                                                                    />
                                                                </td>
                                                                <td>
                                                                    {/* <input
                                                                        type="text"
                                                                        className="form-control mx-auto"
                                                                        name="condition"
                                                                        placeholder={GridData[index].condition}
                                                                        onChange={(e) => onChange(index, e)}


                                                                    /> */}
                                                                    <div className="col-xl-12 col-lg-12 pt-1 mt-1 mt-lg-0 pt-lg-1">
                                                                        <ConditionNameDDL
                                                                            ConditionID={ConditionID}
                                                                            setConditionID={setConditionID}
                                                                            apiFlag='Master'
                                                                            Flag={flag}
                                                                            data={GridData && GridData[index]}
                                                                            IsPost=''
                                                                        />

                                                                    </div>
                                                                </td>

                                                                <td align="center">
                                                                {/* <i class="fa-solid fa-floppy-disk"></i> */}
                                                                    <i className="fa-solid fa-floppy-disk mx-2 " title="Edit" style={{fontSize:'18px'}}
                                                                        onClick={() => handleSubmit(index)}
                                                                    ></i>
                                                                    <i className="fa fa-trash mx-2 text-danger"
                                                                        onClick={() => handleShowDelete(i)}
                                                                        title="Do you want to delete this record?"
                                                                        style={{fontSize:'15px'}}
                                                                    // onClick={() => handleShowDelete()}
                                                                    ></i>
                                                                </td>

                                                            </tr>
                                                        )
                                                    })
                                                        :
                                                        <>No data found</>
                                                }

                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {
                ShowDeletePopup ?
                    <DeletePopUP
                        handleShowDelete={handleShowDelete}
                        ShowDeletePopupData={ShowDeletePopupData}
                        handleDeleteData={handleDeleteData}

                    /> : <></>
            }
        </>);
}

export default SamplePlantNoOfPopup;